import Bowser from 'bowser';
export function getUserBrowser() {
    const browserAgent = navigator.userAgent;
    const browser = Bowser.getParser(browserAgent);
    return browser.getBrowserName();
}
